<template>
  <div>
    <div id="wacs-widget">
      <div v-if="loading" class="loading">
        <img style="height: 80px; width: 80px; padding: 10px; opacity: 0.2;" alt="loading-gif" :src="require('./assets/loader.gif')" />
      </div>
      <div v-if="errors" class="errors">
        {{ getTranslation('COULDNT_LOAD') }}
        <br>
        <br>
        {{ errors }}
      </div>
      <div
        v-if="!loading && !errors"
        :class="{
          'hide': !imagesloaded,
          'show': imagesloaded
        }">
        <Gallery
          :photos="photos"
          :getTranslation="getTranslation"
          v-on:imagesloaded="imagesloaded = true;"/>
        <div style="text-align: center; padding-top: 30px;" v-if="!eventName">
          <h1>{{ getTranslation('COULDNT_LOAD') }}</h1>
        </div>    
        <ActivityPage
          v-if="!showCheckout && !showThankYouPage && eventName"
          :eventName="eventName"
          :eventLength="eventLength"
          :eventDifficulty="eventDifficulty"
          :categories="categories"
          :included="included"
          :excluded="excluded"
          :requirements="requirements"
          :attention="attention"
          :eventDescriptionText="eventDescriptionText"
          :eventMeetingPlacesText="eventMeetingPlacesText"
          :eventTransportationText="eventTransportationText"
          :selectedDate="selectedDate"
          :participants="activeParticipants"
          :checkoutLoading="checkoutLoading"
          :participantPossibilities="participantPossibilities"
          :activityType="activityType"
          :calenderWeeks="calenderWeeks"
          :languages="languages"
          :cancellationPolicy="cancellationPolicy"
          :calendarLoading="calendarLoading"
          :calendarErrors="calendarErrors"
          :checkoutErrors="checkoutErrors"
          :bookingCutoff="bookingCutoff"
          :excerpt="excerpt"
          :selectedTime="selectedTime"
          :setSelectedTime="setSelectedTime"
          :startPoints="startPoints"
          :eventItenary="eventItenary"
          :activityAttributes="activityAttributes"
          :activityCategories="activityCategories"
          :guidanceTypes="guidanceTypes"
          :occupancySum="occupancySum"
          :maxOccupancy="maxOccupancy"
          :inclusions="inclusions"
          :exclusions="exclusions"
          :pickupPlaces="pickupPlaces"
          :rateInfos="rateInfos"
          :videos="videos"
          :requestDeadlineDays="requestDeadlineDays"
          :requestDeadlineHours="requestDeadlineHours"
          :requestDeadlineMinutes="requestDeadlineMinutes"
          :requestDeadlineWeeks="requestDeadlineWeeks"
          :selectedRate="selectedRate"
          :setSelectedRate="setSelectedRate"
          :hideRateSelection="hideRateSelection"
          :formValues="formValues"
          :activeMonth="activeCalenderMonth"
          :setActiveMonth="setActiveCalenderMonth"
          :activeYear="activeCalenderYear"
          :setActiveYear="setActiveCalenderYear"  
          :getTranslation="getTranslation"
          :capacityType="capacityType"
          :formValidations="formValidations"
          v-on:reload-calender="reloadCalender"
          v-on:toggleCheckout="toggleCheckout"
          v-on:update-cart="updateCart"
        />
        <CheckoutPage
          v-if="showCheckout && !showThankYouPage"
          v-on:toggleCheckout="toggleCheckout"
          :eventName="eventName"
          :selectedDate="selectedDate"
          :selectedRate="selectedRate"
          :participants="activeParticipants"
          :pickupPlaces="pickupPlaces"
          :pickupMinutesBefore="pickupMinutesBefore"
          :pickupTimeByLocations="pickupTimeByLocations"
          :getTranslation="getTranslation"
          :contactQuestions="contactQuestions"
          :bookingQuestions="bookingQuestions"
          :selectedTime="selectedTime"
          :activityBookings="activityBookings"
          :extras="extras"
          :checkoutLoading="checkoutLoading"
          :formValues="formValues"
          :formValidations="formValidations"
          :formAmounts="formAmounts"
          :pickup="pickup"
          :paymentMethods="paymentMethods"
          :checkoutOptionsLoading="checkoutOptionsLoading"
          :sanitizeText="sanitizeText"
          :areaCodes="areaCodes"
          :contactPersonSameAsFirstParticipant="contactPersonSameAsFirstParticipant"
          :setContactPersonSameAsFirstParticipant="setContactPersonSameAsFirstParticipant"
          :options="options"
          :paymentFailureMessage="paymentFailureMessage"
          :setPaymentFailureMessage="setPaymentFailureMessage"
          :dropoff="dropoff"
          :paymentHtmlForm="paymentHtmlForm"
          :paymentReferenceNumber="paymentReferenceNumber"
          :totalDue="totalDue"
          :prebookingId="prebookingId"
          :paymentLoading="paymentLoading"
          :paymentErrors="paymentErrors"
          :setPaymentErrors="setPaymentErrors"
          :getPaymentForm="getPaymentForm"
          :selectedPickup="selectedPickup"
          :selectedDropoff="selectedDropoff"
          :selectedExtras="selectedExtras"
          :setSelectedExtras="setSelectedExtras"
          :setSelectedPickup="setSelectedPickup"
          :setSelectedDropoff="setSelectedDropoff"
          :filterExtras="filterExtras"
          :terms="terms"
          :getPriceById="getPriceById"
          :currencyRegexSum="currencyRegexSum"
          :combinedAdditionals="combinedAdditionals"
          :pickupQuestions="pickupQuestions"
          :dropoffQuestions="dropoffQuestions"
          :setFormValues="setFormValues"
          :updateShoppingCartPrices="updateShoppingCartPrices"
        />
        <ThankYouPage
          v-if="showThankYouPage"
          :eventName="eventName"
          :totalDueAsText="totalDueAsText"
          :participants="activeParticipants"
          :prebookingId="prebookingId"
          :selectedDate="selectedDate"
          :selectedTime="selectedTime"
          :getTranslation="getTranslation"
          :selectedRate="selectedRate"
          :selectedExtras="selectedExtras"
          :selectedPickup="selectedPickup"
          :selectedDropoff="selectedDropoff"
          :filterExtras="filterExtras"
          :formValues="formValues"    
          :formAmounts="formAmounts"
          :getPriceById="getPriceById"
          :currencyRegexSum="currencyRegexSum"          
          :combinedAdditionals="combinedAdditionals"
          :pickup="pickup"
          :dropoff="dropoff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityPage from './components/ActivityPage.vue'
import CheckoutPage from './components/CheckoutPage.vue'
import Gallery from './components/Gallery.vue'
import ThankYouPage from './components/ThankYouPage.vue'
import {
  getActivityById,
  getCalendar,
  getCheckout,
  getPickupPlaces,
  getPaymentData,
  getPrebookingById
} from './services'
import { translations } from './translations'
import areaCodes from './assets/areaCodes.js'

const initialData = {
  activeLanguage: 'en',
  loading: true,
  calendarLoading: false,
  calendarErrors: '',
  checkoutLoading: false,
  checkoutErrors: '',
  errors: '',
  showCheckout: false,
  selectedDate: '',
  participants: {},
  contactQuestions: [],
  photos: [],
  eventName: '',
  eventLength: 0,
  eventDifficulty: '',
  categories: [],
  included: '',
  excluded: '',
  requirements: '',
  attention: '',
  eventDescriptionText: '',
  eventMeetingPlacesText: '',
  eventTransportationText: '',
  eventItenary: [],      
  participantPossibilities: [],
  calenderWeeks: null,
  cancellationPolicy: {},
  bookingQuestions: [],
  languages: [],
  activityType: '',
  excerpt: '',
  bookingCutoff: 0,
  activeYear: null,
  activeMonth: null,
  activeId: 6449, // mock
  activeParticipants: {},
  startPoints: [],
  selectedTime: {},
  occupancySum: 0,
  maxOccupancy: 12,
  activityBookings: [],
  pickupPlaces: [],
  pickupMinutesBefore: null,
  dropoffPlaces: [],
  selectedRate: {},
  rateInfos: [],
  extras: {},
  pickup: {},
  dropoff: {},
  activityAttributes: [],
  activityCategories: [],
  guidanceTypes: [],
  inclusions: [],
  exclusions: [],
  totalDueAsText: '',
  paymentHtmlForm: '',
  paymentReferenceNumber: '',
  totalDue: null,
  prebookingId: '',
  paymentLoading: false,
  paymentErrors: '',
  formValues: {},
  formValidations: {},
  formAmounts: {},
  options: [],
  imagesloaded: false,
  videos: [],
  paymentFailureMessage: '',
  showThankYouPage: false,
  selectedPickup: null,
  selectedDropoff: null,
  selectedExtras: null,
  pickupSelectionType: '',
  dropoffSelectionType: '',
  pickupTimeByLocations: [],
  pickupQuestions: [],
  dropoffQuestions: [],
  terms: {},
  contactPersonSameAsFirstParticipant: false,
  hideRateSelection: false,
  areaCodes: areaCodes,
  capacityType: '',
  requestDeadlineDays: null,
  requestDeadlineHours: null,
  requestDeadlineMinutes: null,
  requestDeadlineWeeks: null,
  checkoutOptionsLoading: false,
  paymentMethods: [],
  activeCalenderMonth: new Date().getMonth() + 1,
  activeCalenderYear: new Date().getYear() + 1900
}

export default {
  name: 'App',
  props: {
    dataId: String
  },
  components: {
    ActivityPage,
    CheckoutPage,
    Gallery,
    ThankYouPage
  },
  data: function () {
    return initialData
  },
  mounted: function () {
    const urlParams = new URLSearchParams(window.location.search);
    const idParam = urlParams.get('id')
    const statusParam = urlParams.get('status')
    const tokenParam = urlParams.get('token')
    const prebookingIdParam = urlParams.get('prebookingId')
    const langParam = urlParams.get('lang')

    if (langParam) {
      this.activeLanguage = langParam
    } else {
      const htmlLang = document.documentElement.lang
      this.activeLanguage = htmlLang || 'en'
    }

    if (statusParam && tokenParam && prebookingIdParam) {
      this.loading = true
      getPrebookingById(prebookingIdParam, tokenParam, this.activeLanguage).then(res => {
        const savedData = JSON.parse((res && res.widgetData) || '{}')
        const keys = Object.keys(savedData)

        console.log('GET - widgetData', savedData, 'Res: ', res)  

        if (statusParam === 'cancel') {          
          if (savedData['activeId']) {
            keys.forEach(_ => {
              if (_ === 'checkoutLoading' || _ === 'paymentLoading') {
                console.log('_')
              } else if (_ === 'paymentFailureMessage') {
                this[_] = this.getTranslation('PAYMENT_FAILURE_MESSAGE')
              } else {
                this[_] = savedData[_]
              }
            })
          }
        }

        if (statusParam === 'ok') {
          this.photos = savedData['photos']
          this.showThankYouPage = true
          this.eventName = savedData['eventName']
          this.totalDueAsText = res.totalDueAsText
          this.participants = savedData['participants']
          this.activeParticipants = savedData['activeParticipants']
          this.prebookingId = res.prebookingId
          this.selectedDate = savedData['selectedDate']
          this.selectedTime = savedData['selectedTime']
          this.selectedRate = savedData['selectedRate']
          this.selectedPickup = savedData['selectedPickup']
          this.selectedDropoff = savedData['selectedDropoff']
          this.formValues = savedData['formValues']
          this.selectedExtras = savedData['selectedExtras']
          this.activeLanguage = savedData['activeLanguage']
        }

        this.loading = false
      })
      return
    }

    // get id 6449 if no path in url
    let activityId = 6449
    if (this.dataId) {
      activityId = this.dataId
    }
    if (idParam) {
      activityId = (idParam !== 'index.html') ? idParam : activityId
    }
    
    this.activeId = activityId
    this.getActivityPage(activityId)
  },
  methods: {
    setPaymentErrors: function (newValue) {
      this.paymentErrors = newValue
    },
    setActiveCalenderMonth: function (newValue) {
      this.activeCalenderMonth = newValue
    },
    setActiveCalenderYear: function (newValue) {
      this.activeCalenderYear = newValue
    },
    setContactPersonSameAsFirstParticipant: function (newValue) {
      this.contactPersonSameAsFirstParticipant = newValue
    },
    changeToUrlPath: function (path) {
      window.location = window.location.href.split("?")[0] + '?id=' + path
    },
    setFormValues: function (newFormValues) {
      this.formValues = newFormValues
    },
    setPaymentFailureMessage: function (newPaymentFailureMessage) {
      this.paymentFailureMessage = newPaymentFailureMessage
    },
    updateShoppingCartPrices: function () {
      this.checkoutOptionsLoading = true
      //const parseParticipants = this.formatParticipants(this.activeParticipants)
      
      // Participants to right format
      const parseParticipants = this.activityBookings[0].passengers.map((_, index) => {
        return {
          pricingCategoryId: _.pricingCategoryId,
          passengerDetails: [],
          answers: [
            ...(_.questions.map(a => {
              return {
                questionId: a.questionId,
                values: [ this.formValues[ 'passenger-' + index + '-question-' + a.questionId ] ]
              }
            })),
            ...this.flatten(
              Object.keys(this.selectedExtras || {})
                .filter(_ => _.includes('indExtra'))
                .filter(_ => _ && Number(_.split('-')[2]) === index)
                .map(_ => {
                  const extraId = this.selectedExtras[_].id
                  const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])

                  return extraAnswers.map(a => {
                      return a && {
                        questionId: a.questionId,
                        values: [this.formValues[_ + 'input' + a.questionId]]
                      }
                    })
                    .filter(_ => _)
              })
            )
          ],
          extras: [
            ...Object.keys(this.selectedExtras || {})
              .filter(_ => _.includes('indExtra'))
              .filter(_ => _ && Number(_.split('-')[2]) === index)
              .map(_ => {
                const extraId = this.selectedExtras[_].id
                const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])

                return extraAnswers.length > 0 ? {
                  extraId: extraId,
                  answers: extraAnswers.map(q => ({
                    questionId: q.questionId,
                    values: [this.formValues[_ + 'input' + q.questionId]]
                  })),
                  quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
                } : {
                  extraId: extraId,
                  answers: [],
                  quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
                }
            })
            .filter(_ => _.extraId)
          ]
        }
      })

      // Extras to right format
      let parsedExtras = [
        ...Object.keys(this.selectedExtras || {})
          .filter(_ => _.includes('extra'))
          .map(_ => {
            const extraId = this.selectedExtras[_].id
            const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])

            return extraAnswers.length > 0 ? {
              extraId: extraId,
              answers: extraAnswers.map(q => ({
                questionId: q.questionId,
                values: [this.formValues[_ + 'input' + q.questionId]]
              })),
              quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
            } : {
              extraId: extraId,
              answers: [],
              quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
            }
        })
        .filter(_ => _.extraId)
      ]

      // Pickup to right format
      let parsedPickup = this.pickupSelectionType === 'PRESELECTED' ? {
        pickup: true,
        pickupPlaceId: this.pickupPlaces[0].id,
        pickupDescription: this.pickupPlaces[0].title,
        pickupAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('pickup-question'))
            .map(_ => {
              return {
                questionId: _.split('pickup-question')[1],
                values: [this.formValues[_]]
              }
            })
      } : {}
      if (this.selectedPickup && this.selectedPickup.id && (this.formValues['checkbox-pickup-wanted'] || this.pickup.selectionType === 'PRESELECTED' )) {
        parsedPickup = {
          pickup: true,
          pickupPlaceId: this.selectedPickup.id,
          pickupDescription: this.selectedPickup.title,
          pickupAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('pickup-question'))
            .map(_ => {
              return {
                questionId: _.split('pickup-question')[1],
                values: [this.formValues[_]]
              }
            })
        }
      }

      // Dropoff to right format
      let parsedDropoff = this.dropoffSelectionType === 'PRESELECTED' ? {
        dropoff: true,
        dropoffPlaceId: this.dropoffPlaces[0].id,
        dropoffDescription: this.dropoffPlaces[0].title,
         dropoffAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('dropoff-question'))
            .map(_ => {
              return {
                questionId: _.split('dropoff-question')[1],
                values: [this.formValues[_]]
              }
            })
      } : {}
      if (this.selectedDropoff && this.selectedDropoff.id && (this.formValues['checkbox-dropoff-wanted'] || this.dropoff.selectionType === 'PRESELECTED')) {
        parsedDropoff = {
          dropoff: true,
          dropoffPlaceId: this.selectedDropoff.id,
          dropoffDescription: this.selectedDropoff.title,
           dropoffAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('dropoff-question'))
            .map(_ => {
              return {
                questionId: _.split('dropoff-question')[1],
                values: [this.formValues[_]]
              }
            })
        }
      }

      getCheckout(
        this.activeId,
        this.selectedDate,
        this.selectedTime.id,
        parseParticipants,
        this.selectedRate,
        this.activeLanguage,
        parsedPickup,
        parsedDropoff,
        parsedExtras
      ).then(res => {
          console.log('POST - Checkout options ', res)
          if (res) {
            this.options = res.options
            this.activityBookings = res.questions && res.questions.activityBookings
            this.pickupQuestions = (res.questions && res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].pickupQuestions) || []
            this.dropoffQuestions = (res.questions && res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].dropoffQuestions) || []
            this.bookingQuestions = (res.questions && res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].extras) || []
            this.terms = res.terms
            this.checkoutOptionsLoading = false
            this.paymentMethods = res.paymentMethods
            return
          }
        })
        .catch(err => {
          console.log('__ERR__', err)
          this.checkoutOptionsLoading = false
        })
    },
    combinedAdditionals: function () {
      return [
        ...Object.values(this.selectedExtras || {}),
        (this.selectedPickup && (this.formValues['checkbox-pickup-wanted'] || this.pickup.selectionType === 'PRESELECTED' )) ? this.selectedPickup : {},
        (this.selectedDropoff && (this.formValues['checkbox-dropoff-wanted'] || this.dropoff.selectionType === 'PRESELECTED')) ? this.selectedDropoff : {},
      ]
    },
    currencyRegexSum: function (...nums) {   
      const parsed = nums.filter(_ => typeof _ === 'string').map(_ => Number(_.replace(/\s/g, '').replace(/,/g, '').slice(0, -1)))
      const sum = '' + parsed.reduce((a, b) => a + b, 0)
      return sum.substring(0, sum.length - 2) + "," + sum.substring(sum.length - 2, sum.length) + ' €'
    },
    getPriceById: function (id, pricing) {
      if (id && pricing) {
        const targetPricing = pricing.filter(_ => _.pricingCategoryId == id)[0]
        return targetPricing ? targetPricing.categoryPrice : ''
      }
      return ''
    },
    filterExtras: function (form) {
      const keys = Object.keys(form)
      const checkboxes = keys.filter(_ => _.substring(0, 8) === 'checkbox')
      const withoutInputs = checkboxes.filter(_ => !_.includes('input'))
      const onlyExtras = withoutInputs.filter(_ => _.includes('extra') || _.includes('Extra'))
      const asObjects = onlyExtras.reduce((acc, cur) => ({ ...acc, [cur]: form[cur]  }), {})
      return asObjects
    },
    setSelectedPickup: function (pickup, selectedValue) {
      if (!selectedValue) {
        this.selectedPickup = null
      } else {
        this.selectedPickup = { ...pickup, ...selectedValue }
      }      
    },
    setSelectedDropoff: function (dropoff, selectedValue) {
      if (!selectedValue) {
        this.selectedDropoff = null
      } else {
        this.selectedDropoff = { ...dropoff, ...selectedValue }
      }       
    },
    setSelectedExtras: function (extras) {
      this.selectedExtras = extras
    },
    getTranslation: function (target) {
      if (translations[target]) {
        return translations[target][this.activeLanguage]
      }
      return target
    },
    getTargetDay: function (date) {
      if (!date) return ''
      const days = [].concat.apply([], this.calenderWeeks.map(_ => _.days));            
      const targetDay = days.filter(_ => _.fullDate === date)[0]
      if (!targetDay) {
        return []
      }
      return targetDay
    },
    getRatesBySelectedTime: function (availableRates, targetRates) {
      return availableRates.filter(_ => {
        return targetRates && targetRates.includes(_.rateId)
      })
    },
    setSelectedTime: function (time) {
      this.hideRateSelection = false
      this.selectedTime = time
      this.selectedRate = {}

      // check if only one date and is available
      const filteredRates = this.getRatesBySelectedTime(this.getTargetDay(this.selectedDate).totalPriceByRate, this.selectedTime.rates)
      const targetRate = filteredRates && filteredRates[0]
      const currentAmountOfParticipants = Object.values(this.activeParticipants).reduce((a,b) => a + (b.amount * b.occupancy), 0)
      
      const targetRateInfos = this.rateInfos.filter(_ => _.id === targetRate.rateId)
      const targetRateInfo = targetRateInfos && targetRateInfos[0]      
      const requiredAmountOfParticipants = targetRateInfo.minPerBooking
      
      if (filteredRates.length === 1 && ( currentAmountOfParticipants >= requiredAmountOfParticipants )) {
        this.hideRateSelection = true
        this.setSelectedRate(targetRate, this.rateInfos)
      }
    },
    setSelectedRate: function (rate, fullRates) {  
      this.selectedRate = rate      
      const targetRate = fullRates.filter(_ => _.id === rate.rateId)[0]
      this.pickupSelectionType = targetRate && targetRate.pickupSelectionType
      this.dropoffSelectionType = targetRate && targetRate.dropoffSelectionType
    },
    updateCart: function (props) {
      const [ newParticipant, date ] = props
      this.activeParticipants = { ...this.activeParticipants, ...newParticipant }
      this.selectedDate = date
      this.selectedTime = {}
      this.selectedRate = {}
    },
    getActivityPage: function (id) {
      this.resetData()
      this.loading = true
      this.errors = ''    
      getActivityById(id, this.activeLanguage)
        .then(_ => {
          console.log('GET - Activity page ' + id, _)

          if (_.fault) {
            console.log('__ERR__', _)     

            /* Adding:
            <meta name="robots" content="noindex"> */
            var meta = document.createElement('meta');
            meta.name = "robots";
            meta.content = "noindex";
            document.getElementsByTagName('head')[0].appendChild(meta);

            this.loading = false
            return 
          }

          this.photos = _.photos,
          this.eventName = _.title
          this.eventLength = _.durationDays*24*60 + _.durationHours * 60 + _.durationMinutes,
          this.eventDifficulty = _.difficultyLevel,
          this.included = _.included,
          this.excluded = _.excluded,
          this.requirements = _.requirements,
          this.attention = _.attention,
          this.eventDescriptionText = _.description,
          this.eventMeetingPlacesText = _.eventMeetingPlacesText,
          this.eventTransportationText = _.noPickupMsg,
          this.participantPossibilities = _.pricingCategories,
          this.cancellationPolicy = _.cancellationPolicy
          this.bookingQuestions = _.bookingQuestions
          this.languages = _.languages
          this.activityType = _.activityType
          this.categories = _.categories
          this.bookingCutoff = _.bookingCutoff
          this.excerpt = _.excerpt
          this.eventItenary = _.agendaItems
          this.startPoints = _.startPoints
          this.rateInfos = _.rates
          this.activityAttributes = _.activityAttributes
          this.activityCategories = _.activityCategories
          this.guidanceTypes = _.guidanceTypes  
          this.exclusions = _.exclusions
          this.inclusions = _.inclusions    
          this.videos = _.videos
          this.pickupMinutesBefore = _.pickupMinutesBefore
          this.pickupTimeByLocations = _.pickupTimeByLocations
          this.capacityType = _.capacityType
          this.requestDeadlineDays = _.requestDeadlineDays,
          this.requestDeadlineHours = _.requestDeadlineHours,
          this.requestDeadlineMinutes = _.requestDeadlineMinutes,
          this.requestDeadlineWeeks = _.requestDeadlineWeeks

          this.loading = false

          let defaultParticipants = {}
          if (this.participantPossibilities && this.participantPossibilities[0]) {
            const firstParticipant = this.participantPossibilities[0]
            defaultParticipants = {
              [firstParticipant.id]: {
                amount: 1,
                masterCategoryId: firstParticipant.masterCategoryId,
                id: firstParticipant.id,
                title: firstParticipant.title,
                occupancy: firstParticipant.occupancy,
                isGroup: firstParticipant.ticketCategory === 'GROUP',
                groupSize: firstParticipant.groupSize
              }
            }
          }

          this.reloadCalender({
            id: this.activeId,
            year: new Date().getYear() + + 1900,
            month: new Date().getMonth() + 1,
            participants: { ...defaultParticipants }
          })
          
        })
        .catch(err => {
          console.log('__ERR__', err)     
          this.loading = false
          this.errors = JSON.stringify(err)
        })
      getPickupPlaces(id, this.activeLanguage)
        .then(_ => {
          console.log('GET - Pickup places', _)
          this.pickupPlaces = _.pickupPlaces
          this.dropoffPlaces = _.dropoffPlaces
        })
        .catch(err => {
          console.log('__ERR__', err)
        })

    },
    reloadCalender: function (query) {
      
      const { id, year, month, participants } = query
      if (id) { this.activeId = id }
      if (year) { this.activeYear = year }
      if (month) { this.activeMonth = month }
      if (participants && Object.keys(participants).length > 0) {
        this.activeParticipants = { ...this.activeParticipants, ...participants }
        
        let j;
        let keys = Object.keys(this.activeParticipants)
        for (j = 0; j < keys.length; j++) {
          this.participantPossibilities = this.participantPossibilities.map(item => {
            if (item.id == keys[j]) {
              return { ...item, amount: this.activeParticipants[keys[j]].amount }
            }
            return item
          })
        }

      }

      const pricingCategorySums = Object.values(this.activeParticipants).reduce(
        (acc, cur) => {
          acc[cur.id] = 0 + (acc[cur.id] ? acc[cur.id] : 0) + cur.amount
          return acc
        },
        {}
      )

      const occupancySum = Object.values(this.activeParticipants).map(_ => _.amount * _.occupancy).reduce((a, b) => a + b, 0)
      this.occupancySum = occupancySum

      this.calendarErrors = ''
      this.calendarLoading = true
      getCalendar(this.activeId, this.activeYear, this.activeMonth, pricingCategorySums, this.activeLanguage)
        .then(res => {
          console.log('GET - Calender ', res)
          if (this.activeMonth === res.calendar.month) {
            this.calenderWeeks = res.calendar.weeks
            this.calendarLoading = false
          }
        })
        .catch(err => {
          console.log('__ERR__', err)
          this.calendarLoading = false
          this.calendarErrors = JSON.stringify(err)
        })
    },
    formatParticipants: function (participants) {
      return Object.values(participants).reduce((acc, cur) => {
        let i;
        for (i = 0; i < cur.amount; i++) {
          if (cur.isGroup) {
            acc.push({ "pricingCategoryId": cur.id, "groupSize": cur.groupSize })
          } else {
            acc.push({ "pricingCategoryId": cur.id })
          }
        }
        return acc
      }, [])
    },
    sanitizeText: function (text) {   
      return text
        .replace(/<b>/g, '')
        .replace(/<\/b>/g, '')
        .replace(/<br>/g, '')
        .replace(/<\/br>/g, '')
        .replace(/<p>/g, '')
        .replace(/<\/p>/g, '')
        .replace(/<h1>/g, '')
        .replace(/<\/h1>/g, '')
        .replace(/<h2>/g, '')
        .replace(/<\/h2>/g, '')
        .replace(/<h3>/g, '')
        .replace(/<\/h3>/g, '')
        .replace(/&#39;/g, "'")
    },
    toggleCheckout: function () {
      this.paymentErrors = ''
      if(!this.showCheckout) {
        this.checkoutErrors = ''
        this.checkoutLoading = true
        const parseParticipants = this.formatParticipants(this.activeParticipants)
        const parsedPickup = this.pickupSelectionType === 'PRESELECTED' ? {
          pickup: true,
          pickupPlaceId: this.pickupPlaces[0].id,
          pickupDescription: this.pickupPlaces[0].title
        } : {}
        const parsedDropoff = this.dropoffSelectionType === 'PRESELECTED' ? {
          dropoff: true,
          dropoffPlaceId: this.dropoffPlaces[0].id,
          dropoffDescription: this.dropoffPlaces[0].title
        } : {}

        getCheckout(
          this.activeId,
          this.selectedDate,
          this.selectedTime.id,
          parseParticipants,
          this.selectedRate,
          this.activeLanguage,
          parsedPickup,
          parsedDropoff,
          []
        ).then(res => {
            console.log('POST - Checkout options ', res)
            if (res.questions) {
              this.contactQuestions = res.questions.mainContactDetails
              this.activityBookings = res.questions.activityBookings
              this.extras = res.extras
              this.pickup = res.pickup
              this.terms = res.terms
              this.paymentMethods = res.paymentMethods
              this.options = res.options
              this.dropoff = res.dropoff
              /* this.pickupQuestions = (res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].pickupQuestions) || []
              this.dropoffQuestions = (res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].dropoffQuestions) || [] */
              this.checkoutLoading = false
              this.showCheckout = !this.showCheckout
              this.bookingQuestions = (res.questions.activityBookings && res.questions.activityBookings[0] && res.questions.activityBookings[0].extras) || []
              window.scrollTo(0,0)              

              // Ugly hack to make mandatory items appear in shopping cart
              setTimeout(() => {
                // get shadowRoot Elements if applicable
                let mandatoryElements = document.querySelectorAll('.mandatory-button')              
                if (!mandatoryElements || mandatoryElements.length === 0) {
                  const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
                  if (wacsElement && wacsElement.shadowRoot) {
                    mandatoryElements = wacsElement.shadowRoot.querySelectorAll('.mandatory-button')
                  }         
                }                
                mandatoryElements.forEach(_ => 
                  setTimeout(() => {
                    _.click()
                  }, 500)                
                )
              }, 500)              
              return
            }

            this.checkoutLoading = false
            this.checkoutErrors = JSON.stringify(res)                
          })
          .catch(err => {
            console.log('__ERR__', err)
            this.checkoutLoading = false
            this.checkoutErrors = JSON.stringify(err)
          }) 
      } else {
        this.showCheckout = !this.showCheckout
      }
    },
    flatten: function (deepArray) {
      return [].concat.apply([], deepArray)
    },
    getPaymentForm: function (paymentMethod) {
      this.paymentErrors = ''
      this.paymentLoading = true

      // Participants to right format
      const parsedParticipants = this.activityBookings[0].passengers.map((passenger, index) => {
        return {
          pricingCategoryId: passenger.pricingCategoryId,
          passengerDetails: [
            ...(passenger.passengerDetails.map(a => {

              if (a.questionId === 'dateOfBirth') {
                const dateOfBirth = this.formValues[ 'passenger-' + index + '-question-' + a.questionId ]
                const formattedDateOfBirth = dateOfBirth && dateOfBirth.split('.').reverse().join('-')
                return {
                  questionId: a.questionId,
                  values: [ formattedDateOfBirth ]
                }
              }

              if (a.questionId === 'phoneNumber') {
                const phoneNumber = this.formValues[ 'passenger-' + index + '-question-' + a.questionId ]
                const areaCode = this.formValues['passenger-' + index + '-question-areacode'] || ''
                const formattedPhoneNumber = areaCode + phoneNumber
                return {
                  questionId: a.questionId,
                  values: [ formattedPhoneNumber ]
                }
              }

              const formValue = this.formValues[ 'passenger-' + index + '-question-' + a.questionId]

              return {
                questionId: a.questionId,
                values: [ formValue && formValue.trim() ]
              }
            }))
          ],
          answers: [
            ...(passenger.questions.map(a => {
              return {
                questionId: a.questionId,
                values: [ this.formValues[ 'passenger-' + index + '-question-' + a.questionId ] ]
              }
            })),
            ...this.flatten(
              Object.keys(this.selectedExtras || {})
                .filter(_ => _.includes('indExtra'))
                .filter(_ => _ && Number(_.split('-')[2]) === index)
                .map(_ => {
                  const extraId = this.selectedExtras[_].id
                  const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])

                  return extraAnswers.map(a => {
                      return a && {
                        questionId: a.questionId,
                        values: [this.formValues[_ + 'input' + a.questionId]]
                      }
                    })
                    .filter(_ => _)
              })
            )
          ],
          extras: [
            ...Object.keys(this.selectedExtras || {})
              .filter(_ => _.includes('indExtra'))
              .filter(_ => _ && Number(_.split('-')[2]) === index)
              .map(_ => {
                const extraId = this.selectedExtras[_].id
                const extraAnswers = (passenger.extras || []).filter(extra => extra.extraId === extraId)[0]

                return (extraAnswers && extraAnswers.questions) ? {
                  extraId: extraId,
                  answers: extraAnswers.questions.map(question => ({
                    questionId: question.questionId,
                    values: [this.formValues[_ + 'input' + question.questionId]]
                  })),
                  quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
                } : {
                  extraId: extraId,
                  answers: [],
                  quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
                }
            })
            .filter(_ => _.extraId)
          ]
        }
      })

      // Contact person to right format
      const parsedContactQuestions = this.contactQuestions.map(_ => {

        if (_.questionId === 'dateOfBirth') {
          const dateOfBirth = this.formValues[ 'mainContactDetails-' + _.questionId ]
          const formattedDateOfBirth = dateOfBirth && dateOfBirth.split('.').reverse().join('-')
          return {
            questionId: _.questionId,
            values: [ formattedDateOfBirth ]
          }
        }

        if (_.questionId === 'phoneNumber') {
          const phoneNumber = this.formValues[ 'mainContactDetails-' + _.questionId ]
          const areaCode = this.formValues['mainContactDetails-areacode'] || ''
          const formattedPhoneNumber = areaCode + phoneNumber
          return {
            questionId: _.questionId,
            values: [ formattedPhoneNumber ]
          }
        }

        const formValue = this.formValues[ 'mainContactDetails-' + _.questionId ]
        
        return {
          questionId: _.questionId,
          values: [ formValue && formValue.trim() ]
        }
      })

      // Questions to right format
      const parsedQuestions = [
        ...this.activityBookings[0].questions.map(_ => {
          return {
            questionId: _.questionId,
            values: [ this.formValues[ 'questions-' + _.questionId ] ]
          }
        }),
        // Flatten because extras can have multiple questions each
        ...this.flatten(
          Object.keys(this.selectedExtras || {})
            .filter(_ => _.includes('extra'))
            .map(_ => {
              const extraId = this.selectedExtras[_].id
              const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])
              
              return extraAnswers.map(a => {
                  return a && {
                    questionId: a.questionId,
                    values: [this.formValues[_ + 'input' + a.questionId]]
                  }
                })
                .filter(_ => _)
            })
        )
      ]

      // Pickup to right format
      let parsedPickup = {}
      if (this.selectedPickup && this.selectedPickup.id && (this.formValues['checkbox-pickup-wanted'] || this.pickup.selectionType === 'PRESELECTED' )) {
        parsedPickup = {
          pickup: true,
          pickupPlaceId: this.selectedPickup.id,
          pickupDescription: this.selectedPickup.title,
          pickupAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('pickup-question'))
            .map(_ => {
              return {
                questionId: _.split('pickup-question')[1],
                values: [this.formValues[_]]
              }
            })
        }
      }

      // Dropoff to right format
      let parsedDropoff = {}
      if (this.selectedDropoff && this.selectedDropoff.id && (this.formValues['checkbox-dropoff-wanted'] || this.dropoff.selectionType === 'PRESELECTED')) {
        parsedDropoff = {
          dropoff: true,
          dropoffPlaceId: this.selectedDropoff.id,
          dropoffDescription: this.selectedDropoff.title,
          dropoffAnswers: Object.keys(this.formValues || {})
            .filter(_ => _ && _.includes('dropoff-question'))
            .map(_ => {
              return {
                questionId: _.split('dropoff-question')[1],
                values: [this.formValues[_]]
              }
            })
        }
      }

      // Extras to right format
      let parsedExtras = [
        ...Object.keys(this.selectedExtras || {})
          .filter(_ => _.includes('extra'))
          .map(_ => {
            const extraId = this.selectedExtras[_].id
            const extraAnswers = (this.bookingQuestions || []).filter(_ => _.extraId === extraId).reduce((acc, val) => [ ...acc, ...val.questions ], [])

            return extraAnswers ? {
              extraId: extraId,
              answers: extraAnswers.map(q => ({
                questionId: q.questionId,
                values: [this.formValues[_ + 'input' + q.questionId]]
              })),
              quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
            } : {
              extraId: extraId,
              answers: [],
              quantity: this.formAmounts[_] ? this.formAmounts[_] : 1
            }
        })
        .filter(_ => _.extraId)
      ]

      return getPaymentData(
        this.activeId,
        this.selectedDate,
        this.selectedTime.id,
        parsedParticipants,
        parsedQuestions,
        parsedPickup,
        parsedDropoff,
        parsedContactQuestions,
        parsedExtras,
        this.activeLanguage,
        this.selectedRate,
        this.$data,
        paymentMethod
      ).then(res => {
        console.log('POST - Payment ', res)
        if (res.fault) {
          this.paymentLoading = false
          this.paymentErrors = JSON.stringify(res)
          return 'FAILURE'
        }
        this.totalDueAsText = res.totalDueAsText
        if (res.paymentHtmlForm) {
          this.paymentHtmlForm = res.paymentHtmlForm.replace('<form', '<form id="payment-form"')
        }
        this.paymentReferenceNumber = res.paymentReferenceNumber
        this.totalDue = res.totalDue
        this.prebookingId = res.prebookingId
        this.paymentLoading = false
        return 'SUCCESS'
      }).catch(err => {
        console.log('__ERR__', err)
        this.paymentLoading = false
        this.paymentErrors = JSON.stringify(err)
        return 'ERROR'
        })
    },
    resetData: function () {
      this.loading = true,
      this.calendarLoading = false,
      this.calendarErrors = '',
      this.checkoutLoading = false,
      this.checkoutErrors = '',
      this.errors = '',
      this.showCheckout = false,
      this.selectedDate = '',
      this.selectedRate = {},
      this.participants = {},
      this.contactQuestions = [],
      this.photos = [],
      this.eventName = '',
      this.eventLength = 0,
      this.eventDifficulty = '',
      this.categories = [],
      this.included = '',
      this.excluded = '',
      this.requirements = '',
      this.attention = '',
      this.eventDescriptionText = '',
      this.eventMeetingPlacesText = '',
      this.eventTransportationText = '',      
      this.participantPossibilities = [],
      this.calenderWeeks = null,
      this.cancellationPolicy = {},
      this.bookingQuestions = [],
      this.languages = [],
      this.activityType = '',
      this.bookingCutoff = 0,
      this.activeYear = null,
      this.activeMonth = null,
      this.activeParticipants = {},
      this.occupancySum = 0
    },
  }
}
</script>

<style>
.hide {
  opacity: 0;
}
.show {
  opacity: 1;
}
.errors {
  text-align: center;
  padding-top: 60px;
  font-size: 1rem;
}
.loading {
  text-align: center;
  padding-top: 60px;
  font-size: 1rem;
}
body {
  margin: 0px;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
  -webkit-tap-highlight-color: transparent;
}
input {
  padding: 10px;
  border: 1px solid rgb(230,230,230);
  border-radius: 2px;
  min-width: 250px;
}
select {
  padding: 10px;
  border: 1px solid rgb(230,230,230);
  border-radius: 2px;
  min-width: 100px;
  background-color: white;
  color: #777777;
}
button {
  outline: none;
  padding: 0px;
  margin: 0px;
}
#wacs-widget {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'Libre Franklin', sans-serif;
  letter-spacing: 0.05rem;
  font-size: 14px;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(87, 100, 111);
  max-width: 1200px;
  margin: auto;
  padding-bottom: 80px;
}
.blue-text {
  color: #0092C8;
}
h3 {
  font-size: 0.81rem;
  letter-spacing: 0.0rem;
  margin-bottom: 0px;
}
h1 {
  font-size: 1.5rem;
  letter-spacing: 0.0rem;
}
p {
  line-height: 1.5;
  letter-spacing: 0rem;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
}
.box {
  border: 1px solid rgba(0,0,0,0.1);
  padding: 0px;
  padding-top: 0px;
  padding-bottom: 10px;
  margin-top: 10px;
  box-shadow: 0px 0px 7px rgb(235,235,235);
}
.box-title {
  text-transform: uppercase;
  padding: 10px;
  padding-top: 0px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
@media only screen and (max-width: 450px) {
  input {
    min-width: 200px;
  }
  .nav-button {
    font-size: 8px;
  }
}
@keyframes fade-in {
  from {opacity: 0}
  to {opacity: 1}
}
</style>
